import { createBrowserHistory } from "history";

/**
 * Application history instance for programmatic navigation.
 * Created using the HTML5 History API using the 'history' library.
 */
export const appHistory = createBrowserHistory();

export default appHistory;
